module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "title": _vm.content.basename
    }
  }, [_vm._v(_vm._s(_vm.content.basename))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-link",
    on: {
      "click": _vm.attachFile
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d2beb46","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/FileUploader/File.vue
// module id = 858
// module chunks = 0